<wizard-labeled-field label="Duration" [size]="fieldSize">
    <wizard-tooltip>
        Duration is how long your meeting will last for. The default for this setting comes from your associated Meeting
        Type.
        <a
            href="https://faq.calendarhero.com/hc/en-us/articles/4430389795355-What-can-my-assistant-understand-"
            target="_blank"
            >Learn More</a
        >
    </wizard-tooltip>
    <div class="ui duration selection dropdown" [ngClass]="{ loading: isLoading, teal: isLoading }" id="duration">
        <i *ngIf="!isLoading && !isPlugin" class="clock outline icon bluegrey margin-right-10"></i>
        <input type="hidden" name="duration" />
        <i class="dropdown icon"></i>
        <div class="default text">Duration</div>
    </div>
</wizard-labeled-field>
